export default {
  formId: "qr-code",
  formField: {
    description: {
      name: "description",
      label: "Description",
      type: "text",
      errorMsg: "Description is required.",
      invalidMsg: "Description is invalid",
    },
    location: {
      name: "location",
      label: "Location",
      type: "select",
      errorMsg: "location is required.",
      invalidMsg: "Location is not valid",
    },
    timezone: {
      name: "timezone",
      label: "Timezone",
      type: "select",
      errorMsg: "Timezone is required.",
      invalidMsg: "Timezone is not valid",
    },
    area: {
      name: "area",
      label: "Area",
      // type: "text",
      errorMsg: "Area is required.",
      invalidMsg: "Area is invalid",
    },
    project: {
      name: "project",
      label: "SubAccount",
      type: "text",
      errorMsg: "SubAccount is required.",
      invalidMsg: "SubAccount is invalid",
    },
    status: {
      name: "status",
      label: "Status",
      type: "switch",
      errorMsg: "Status is required.",
      invalidMsg: "Status is invalid",
    },
    mapCenter: { name: "mapCenter" },
    mapZoom: { name: "mapZoom" },
    profileImage: {
      name: "profileImage",
      label: "Activate to take profile image when clocking out",
      type: "switch",
      errorMsg: "Status is required.",
      invalidMsg: "Status is invalid",
    },
    signShift: {
      name: "signShift",
      label: "Activate to sign shift when clocking out",
      type: "switch",
      errorMsg: "Status is required.",
      invalidMsg: "Status is invalid",
    },
    collectIP: {
      name: "collectIP",
      label: "Collect ip address every time employee clock in or clock out",
      type: "switch",
      errorMsg: "Status is required.",
      invalidMsg: "Status is invalid",
    },
  },
};
